import DataRoomNdasEmptyScreen from './DataRoomNdasEmptyScreen.component';

export default DataRoomNdasEmptyScreen;